<template>
  <v-container fluid>
    <div class="title">{{ title }}</div>

    <div class="loading" v-if="loading">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
    </div>

    <P1NotificationDetails v-if="!loading" :feeds="feeds" :headers="headers" />
  </v-container>
</template>

<script>
import { Auth } from "aws-amplify";
import AWS from "aws-sdk";
import P1NotificationDetails from "./P1NotificationDetails.vue";

export default {
  props: ["title"],

  components: {
    P1NotificationDetails
  },

  data: () => ({
    loading: true,
    headers: [
      {
        text: "Date",
        value: "date",
        width: 200,
        sortable: false
      },
      {
        text: "Next Update",
        value: "next_update",
        width: 250,
        sortable: false
      },
      {
        text: "Status",
        value: "status",
        sortable: false
      },
      {
        text: "Resolution",
        value: "resolution",
        sortable: false
      },
      {
        text: "Root Cause",
        value: "root_cause",
        sortable: false
      },
      {
        text: "Time Resolved",
        value: "time_resolved",
        sortable: false
      }
    ],
    feeds: []
  }),

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;

      const creds = await Auth.currentCredentials();

      const dynamodb = new AWS.DynamoDB.DocumentClient({
        credentials: creds,
        region: "us-west-2"
      });

      let partitions = [
        new Date(),
        new Date(),
        new Date(),
        new Date(),
        new Date(),
        new Date()
      ];
      partitions.forEach((v, idx) => {
        v.setDate(v.getDate() - idx);
      });

      let items = await this.fetchDataByPartition(
        dynamodb,
        partitions.reverse()
      );
      this.feeds = await this.mapData(items);

      this.loading = false;
    },

    async mapData(data) {
      // for each entry in the data array, we need to break it up into multiple keys where each key has it own set of logs
      let m = new Map();

      const date_opts = {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      };

      const time_opts = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      };

      data.forEach(x => {
        if (!m.has(x.IncidentID)) {
          m.set(x.IncidentID, { notifications: [] });
        }

        let i = m.get(x.IncidentID);
        let raw_date = x.AlertDate + "T" + x.AlertTime + "Z";

        i.incident_id = x.IncidentID;
        i.name = x.Name;
        i.notification_time = x.NotificationTime;
        i.report_method = x.ReportMethod;
        i.outage = x.Outage;
        i.escalated_teams = x.ITTeamEscalatedTo;
        i.location_impact = x.LocationImpact;
        i.business_impact = x.BusinessImpact;
        i.company_impact = x.CompanyImpact;
        i.cpr_notified = x.CPRNotified;
        i.message = x.Message;
        i.description = x.Description;

        i.notifications.push({
          raw_date: raw_date,
          date:
            new Date(raw_date).toLocaleDateString("default", date_opts) +
            " " +
            new Date(raw_date).toLocaleTimeString("default", time_opts),
          next_update: x.NextUpdate,
          status: x.Status,
          resolution: x.Resolution,
          root_cause: x.RootCause,
          time_resolved: x.TimeResolved
        });
      });

      // m.forEach(v => {
      //   v.sort((a, b) => {
      //     return a.raw_date > b.raw_date ? -1 : a.raw_date < b.raw_date ? 1 : 0;
      //   });
      // });

      return Array.from(m.values());
    },

    async fetchDataByPartition(db, partitions) {
      let results = await Promise.all(
        partitions.map(async (p, idx) => {
          let filter = {
            TableName: "p1-alerts-v4",
            IndexName: "p1-alerts-by-time-v4",
            AttributesToGet: [
              "AlertDate",
              "AlertTime",
              "IncidentID",
              "Name",
              "NotificationTime",
              "ReportMethod",
              "CompanyImpact",
              "LocationImpact",
              "BusinessImpact",
              "ITTeamEscalatedTo",
              "CPRNotified",
              "Outage",
              "Status",
              "NextUpdate",
              "Message",
              "Description",
              "TimeResolved",
              "Resolution",
              "RootCause"
            ],
            KeyConditions: {
              AlertDate: {
                ComparisonOperator: "EQ",
                AttributeValueList: {
                  S: p.toISOString().match(/(.*)T(.*)Z/)[1]
                }
              }
            }
          };

          if (idx === 0) {
            filter.KeyConditions.AlertTime = {
              ComparisonOperator: "GE",
              AttributeValueList: {
                S: p.toISOString().match(/(.*)T(.*)Z/)[2]
              }
            };
          }

          let r = await db.query(filter).promise();
          return r.Items;
        })
      );

      return results.flat();
    }
  }
};
</script>
